import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { MessageBox, Message, Loading } from 'element-ui'

Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'small' })
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$loading = Loading.service

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
